import { render } from "./CardsSettingsPanel.vue?vue&type=template&id=8d9424ca"
import script from "./CardsSettingsPanel.vue?vue&type=script&lang=js"
export * from "./CardsSettingsPanel.vue?vue&type=script&lang=js"

import "./CardsSettingsPanel.vue?vue&type=style&index=0&id=8d9424ca&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__